import {observable} from "mobx";

class AddressStore {
    @observable _list = [];

    get list() {
        return this._list;
    }

    set list(value) {
        this._list = value;
    }
}

const store = new AddressStore()

export default store
